//Used for loading between screens and displaying relevant text
const Loading = ({ loadingText, show = true }) => {
  if (!show) {
    return null;
  }
  return (
    <div
      style={{ textAlign: 'center', justifyContent: 'center' }}
      className="loading-screen"
    >
      <h4 style={{ fontWeight: 'bold' }} className="loading-text">
        {loadingText}
      </h4>
    </div>
  );
};

export default Loading;
